export default __webpack_public_path__ + "static/media/modal_designer.b0419487.png";